import React from "react";
import { Route, Routes } from "react-router-dom";
import Items from "./Items";
import ResourceNotFound from "../../Common/ResourceNotFound";
import PaymentIn from "../Sales/PaymentIn";
import SubSaleInvoice from "../Sales/SubSalesInvoice";
import CreditNotes from "../Sales/CreditNotes";
import SalesOrderDashboard from "../Sales/SalesOrderDashboard";
import { ItemType } from "../../Services/ItemsService";
import LedgerTable from "../Master/Ledger/LedgerTable";
import { SearchLedgerByGroupsTypes } from "../../Services/LedgerService";
import {
  findUserOnlyOnePremission,
  findUserPremission,
} from "../Users/UserSecurityFind";
import { useUser } from "../../../Context/UserContext";
import { useClient } from "../../Context/ClientContext";
import { SettingsSections } from "../../Services/SettingService";
import { IPermissionActionType } from "../Users/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../../Context/RoleContext";

const PurchaseNestedRoute = () => {
  const { clientSpecificRole } = useUser();
  const { currentClient } = useClient();
  return (
    <Routes>
      <Route
        path="/purchaseBill"
        element={
          findUserPremission(
            ["Voucher.Purchase.Bill.View"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.PurInvoice],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <SubSaleInvoice />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path="/debitNote"
        element={
          findUserPremission(
            ["Voucher.Purchase.DebitNote.View"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.DrNote],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <CreditNotes />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path="/paymentOut"
        element={
          findUserPremission(
            ["Voucher.Purchase.PaymentOut.View"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.Payment],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <PaymentIn />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path="/order"
        element={
          findUserPremission(
            ["Voucher.Purchase.PurchaseOrder.View"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.POrder],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <SalesOrderDashboard />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/* <Route
        path="/items"
        element={<Items itemPage={ItemType.PurchaseItems} />}
      /> */}
      <Route
        path="/suppliers"
        element={
          findUserOnlyOnePremission(
            "Master.Ledger.Suppliers.View",
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <LedgerTable
              ledgerByGroupsType={SearchLedgerByGroupsTypes.CreditorsOnly}
              showName={"Supplier"}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      ></Route>

      <Route path="*" element={<ResourceNotFound pageHeight="100%" />} />
    </Routes>
  );
};

export default PurchaseNestedRoute;
